import { Global } from "@emotion/react"
import { ByfolioProvider } from "@alexandrudanpop/byfolio-ui"
import React, { type ReactNode } from "react"
import type { GatsbyLocation } from "../compat/gatsby-public-api"
import type { GatsbyStaticQueryRuntime } from "../compat/gatsby-public-api"
import FooterConsentAction from "../components/footer-consent-action"
import styles from "./layout.styles"
import styleColors from "./layoutColors.styles"

const { graphql, useStaticQuery }: GatsbyStaticQueryRuntime = require("gatsby")

interface LayoutStaticQueryData {
  readonly site: {
    readonly siteMetadata: {
      readonly copyrightYear: number
    } | null
  } | null
}

interface LayoutProps {
  readonly children: ReactNode
  readonly location: GatsbyLocation
}

const Layout = ({ children }: LayoutProps) => {
  const data = useStaticQuery<LayoutStaticQueryData>(graphql`
    query LayoutStaticQuery {
      site {
        siteMetadata {
          copyrightYear
        }
      }
    }
  `)
  const copyrightYear = data.site?.siteMetadata?.copyrightYear

  if (!Number.isInteger(copyrightYear)) {
    throw new TypeError("Missing required site metadata: copyrightYear")
  }

  return (
    <ByfolioProvider>
      <div className="pgContainer">
        <div className="pgContent">
          <Global styles={[styles, styleColors]} />
          {children}
        </div>
        <footer className="copy">
          <div className="copy-inner">
            <span>© {copyrightYear} Alexandru-Dan Pop</span>
            <span className="copy-tagline">Software · AI · Product</span>
            <FooterConsentAction />
          </div>
        </footer>
      </div>
      <span className="bgPageColor" aria-hidden="true">
        .
      </span>
    </ByfolioProvider>
  )
}

export default Layout
